const schema = [
  {
    type: "object",
    title: "Děkujeme, že chcete pomoci s celostátním výzkumem dlouhodobých dopadů nemoci COVID-19",
    description: "Prosím zadejte váš e-mail a potvrďte souhlas se zpracováním údajů. E-mail potřebujeme pro případný návazný dotazník ohledně vašeho stavu. ",
    required: [ "personalDataConsent", "emailAddress" ],
    properties: {
      "emailAddress": {
        title: "E-mail",
        type: "string",
        format: "email"
      },
      "personalDataConsent": {
        title: "",
        type: "boolean",
        enumNames: [ "Souhlasím se zpracováním osobních údajů" ],
        enum: [ true ],
      },
    }
  },
  {
    type: "object",
    title: "Měl/a jste pozitivní PCR test na COVID-19?",
    required: [ "positivePcrTest" ],
    properties: {
      "positivePcrTest": {
        title: "Vyberte prosím jednu z možností",
        type: "string",
        enum: [ "yes-less-than-14-days-ago", "yes-more-than-14-days-ago", "yes-antigen-less-than-14-days-ago", "yes-antigen-more-than-14-days-ago", "no" ],
        enumNames: [
          "Ano, byl/a jsem pozitivně testován/a PCR testem v posledních 14 dnech",
          "Ano, byl/a jsem pozitivně testován/a PCR testem před více než 14 dny",
          "Ano, byl/a jsem pozitivně testován/a antigenním testem v posledních 14 dnech",
          "Ano, byl/a jsem pozitivně testován/a antigenní testem před více než 14 dny",
          "Ne"
        ],
        submitOn: [ "no" ]
      }
    }
  },
  {
    type: "object",
    title: "Uveďte datum pozitivního výsledku PCR testu na SARS-CoV-2. ",
    properties: {
      diagnosisDate: {
        title: "",
        description: "Pokud si nevzpomínáte přesně, uveďte alespoň měsíc a rok.",
        type: "object",
        required: [ "diagnosisMonth", "diagnosisYear" ],
        properties: {
          "diagnosisDay": {
            title: "Den",
            type: "number",
            enum: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31 ]
          },
          "diagnosisMonth": {
            title: "Měsíc",
            type: "number",
            enum: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
            enumNames: [ "leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec" ]
          },
          "diagnosisYear": {
            title: "Rok",
            type: "number",
            enum: [ 2020, 2021, 2022 ]
          }
        }
      }
    }
  }, {
    type: "object",
    title: "Byl/a jste očkován/a proti COVID-19?",
    required: [ "vaccination" ],
    properties: {
      "vaccination": {
        title: "Počet dávek",
        type: "string",
        enum: [ "3 dávky", "2 dávky", "1 dávka", "Žádná" ],
        submitOn: [ "Žádná" ]
      }
    },
    dependencies: {
      "vaccination": {
        "oneOf": [
          {
            "properties": {
              "vaccination": {
                "enum": [
                  "3 dávky", "2 dávky", "1 dávka"
                ]
              },
              "vaccinationDate": {
                title: "Kdy jste byl/a očkován poslední dávkou?",
                description: "",
                required: [ "vaccinationMonth", "vaccinationYear" ],
                properties: {
                  "vaccinationDay": {
                    title: "Den",
                    type: "number",
                    enum: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31 ]
                  },
                  "vaccinationMonth": {
                    title: "Měsíc",
                    type: "number",
                    enum: [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
                    enumNames: [ "leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec" ]
                  },
                  "vaccinationYear": {
                    title: "Rok",
                    type: "number",
                    enum: [ 2020, 2021, 2022 ]
                  }
                }
              }
            }
          }
        ]
      }
    }
  },
  // Začátek: Průběh a příznaky COVID-19
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "headache" ],
    properties: {
      headache: {
        title: "Bolest hlavy",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "highTemperature" ],
    properties: {
      highTemperature: {
        title: "Zvýšená tělesná teplota",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "cough" ],
    properties: {
      cough: {
        title: "Kašel",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "diarrhea" ],
    properties: {
      diarrhea: {
        title: "Průjem",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "musclePain" ],
    properties: {
      musclePain: {
        title: "Bolest svalů nebo jiných částí těla",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "lossOfSmell" ],
    properties: {
      lossOfSmell: {
        title: "Ztráta čichu",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "lossOfTaste" ],
    properties: {
      lossOfTaste: {
        title: "Ztráta chuti",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "breathingDifficulties" ],
    properties: {
      breathingDifficulties: {
        title: "Dechové obtíže",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "conjuctivitis" ],
    properties: {
      conjuctivitis: {
        title: "Zánět spojivky",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "runnyNose" ],
    properties: {
      runnyNose: {
        title: "Výtok z nosu",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "chestPain" ],
    properties: {
      chestPain: {
        title: "Bolest na hrudi",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "fatigue" ],
    properties: {
      fatigue: {
        title: "Nadměrná únava",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "anxiety" ],
    properties: {
      anxiety: {
        title: "Úzkost",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "delirium" ],
    properties: {
      delirium: {
        title: "Zmatenost",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápil vás tento příznak v průběhu onemocnění COVID-19?",
    required: [ "sleepDifficulties" ],
    properties: {
      sleepDifficulties: {
        title: "Problémy se spánkem",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    type: "object",
    title: "Trápily Vás jiné příznaky v průběhu onemocnění COVID-19?",
    properties: {
      otherSymptom: {
        title: "Další příznaky",
        description: "Prosím vypište",
        type: "string"
      }
    },
  },
  // Konec: Průběh a příznaky COVID-19
  {
    title: "Vyžadoval průběh onemocnění COVID-19 hospitalizaci?",
    type: "object",
    required: [ "hospitalisation" ],
    properties: {
      hospitalisation: {
        title: "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ false ]
      }
    },
    dependencies: {
      "hospitalisation": {
        "oneOf": [
          {
            "properties": {
              "hospitalisation": {
                "enum": [ true ]
              },
              hospitalisationDays: {
                title: "Po kolik dní jste byl/a hospitalizována",
                type: "number",
                minimum: 0
              }
            }
          }
        ]
      }
    }
  },
  {
    title: "Vyžadoval průběh onemocnění COVID-19 podporu dýchání nebo kyslíkovou terapii?",
    type: "object",
    required: [ "breathingAid" ],
    properties: {
      breathingAid: {
        title: "",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  {
    title: "Vnímáte průběh onemocnění COVID-19 jako traumatizující životní událost?",
    type: "object",
    required: [ "wasTrauma" ],
    properties: {
      wasTrauma: {
        title: "",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    },
  },
  // Demografie
  {
    title: "Vaše pohlaví",
    type: "object",
    required: [ "gender" ],
    properties: {
      gender: {
        title: "Zaškrtněte",
        type: "string",
        enum: [ "Žena", "Muž" ],
        submitOn: [ "Žena", "Muž" ]
      }
    }
  },
  {
    title: "Váš věk",
    type: "object",
    required: [ "age" ],
    properties: {
      age: {
        title: "",
        type: "number",
        minimum: 0
      }
    }
  },
  {
    type: "object",
    captureMark: "end-of-prospective-capture",
    title: "Nacházíte se ve finanční či společenské tísni nebo v jinak náročné životní situaci, která nesouvisí s Vašim zdravotním stavem?",
    required: [ "financeDifficulties" ],
    properties: {
      financeDifficulties: {
        title: "",
        type: "boolean",
        enum: [ true, false ],
        enumNames: [ "Ano", "Ne" ],
        submitOn: [ true, false ]
      }
    }
  },
  // Konec demografie
  // Zdravotní péče
  {
    type: "object",
    captureMark: "start-of-prospective-capture-second-run",
    title: "Kolikrát jste byl/a hospitalizován/a od chvíle, kdy Vám bylo diagnostikováno onemocnění COVID-19?",
    required: [ "numHospitalizations" ],
    properties: {
      numHospitalizations: {
        title: "",
        type: "number",
        minimum: 0
      }
    }
  },
  {
    type: "object",
    title: "Kolikrát jste navštívil/a lékaře od chvíle, kdy Vám bylo diagnostikováno onemocnění COVID-19?",
    required: [ "numDoctorVisits" ],
    properties: {
      numDoctorVisits: {
        title: "",
        type: "number",
        minimum: 0
      }
    }
  },
  {
    type: "object",
    title: "Kolikrát Vám byly vydány léky na předpis od chvíle, kdy Vám bylo diagnostikováno onemocnění COVID-19?",
    required: [ "numDrugPrescriptions" ],
    properties: {
      numDrugPrescriptions: {
        title: "",
        type: "number",
        minimum: 0
      }
    }
  },
  // Konec zdravotní péče
  // Funkční status po COVID-19 (PCFS)
  {
    title: "Do jaké míry jste momentálně ovlivněn onemocněním COVID-19 v každodenním životě? Prosím označte to z následujících tvrzení, které se hodí nejlépe.",
    type: "object",
    required: [ "everydayLife" ],
    properties: {
      "everydayLife": {
        title: "Vyberte možnost, která nejlépe odpovídá: když se zamyslíte nad předchozím týdnem...",
        "type": "string",
        "enum": [
          "Netrpím žádnými omezeními v každodenním životě, nemám žádné příznaky, bolest, depresi ani úzkost související s infekcí.",
          "Omezení každodenního života jsou zanedbatelná, jelikož jsem schopný/a provozovat všechny povinnosti a běžné aktivity. Stále však trpím přetrvávajícími příznaky, bolestí, depresí nebo úzkostmi.",
          "Trpím omezeními každodenního života, jelikož jsem občas nucen se vyhýbat povinnostem či běžným aktivitám, omezovat je nebo rozkládat v čase v důsledku příznaků, bolesti, deprese nebo úzkosti. Jsem však schopen tyto činnosti vykonávat bez pomoci.",
          "Trpím omezeními každodenního života, jelikož nejsem schopný/a se věnovat povinnostem či běžným aktivitám v důsledku příznaků, bolesti, deprese nebo úzkosti. Jsem nicméně schopný/a se o sebe postarat bez pomoci dalších lidí.",
          "Trpím závažnými omezeními každodenního života. Nejsem schopný/na postarat se o sebe sám/a, a tudíž jsem závislá/ý na pomoci dalších osob v důsledku příznaků, bolesti, deprese nebo úzkosti."
        ],
      }
    }
  },
  // Konec Funkční status po COVID-19 (PCFS)
  // Long-COVID příznaky
  {
    "type": "object",
    "title": "Zotavila/a jste se úplně z onemocnění COVID-19?",
    required: [ "isRecovered" ],
    "properties": {
      "isRecovered": {
        title: "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Cítíte se nemocně?",
    required: [ "feelSick" ],
    "properties": {
      "feelSick": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte dechové obtíže?",
    required: [ "hasBreathingDifficulties" ],
    "properties": {
      "hasBreathingDifficulties": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Cítíte silnější únavu/nedostatek energie než před prodělaným onemocněním COVID-19?",
    required: [ "feelMoreFatigue" ],
    "properties": {
      "feelMoreFatigue": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte kašel?",
    required: [ "hasCough" ],
    "properties": {
      "hasCough": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Trpíte „bušením“ srdce?",
    required: [ "hasHeartBeatingProblems" ],
    "properties": {
      "hasHeartBeatingProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Pociťujete tlak nebo bolest na hrudi?",
    required: [ "feelChestPain" ],
    "properties": {
      "feelChestPain": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte menší fyzickou sílu?",
    required: [ "feelWeakness" ],
    "properties": {
      "feelWeakness": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Bolí Vás svaly?",
    required: [ "feelMusclePain" ],
    "properties": {
      "feelMusclePain": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Bolí Vás hlava?",
    required: [ "feelHeadache" ],
    "properties": {
      "feelHeadache": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Bolí Vás žaludek?",
    required: [ "feelStomachPain" ],
    "properties": {
      "feelStomachPain": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Bolí Vás v krku?",
    required: [ "feelSoarThroat" ],
    "properties": {
      "feelSoarThroat": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Bolí Vás klouby?",
    required: [ "feelJointsPain" ],
    "properties": {
      "feelJointsPain": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Míváte zvýšenou teplotu?",
    required: [ "hasHighTemperature" ],
    "properties": {
      "hasHighTemperature": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte změněný/zhoršený čich?",
    required: [ "hasSmellProblems" ],
    "properties": {
      "hasSmellProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte změněnou/zhoršenou chuť?",
    required: [ "hasTasteProblems" ],
    "properties": {
      "hasTasteProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Trpíte poruchami spánku?",
    required: [ "haveSleepingProblems" ],
    "properties": {
      "haveSleepingProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte zlé vzpomínky nebo noční můry?",
    required: [ "hasNightmares" ],
    "properties": {
      "hasNightmares": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte špatnou náladu nebo malou motivaci cokoliv dělat?",
    required: [ "hasLowMotivation" ],
    "properties": {
      "hasLowMotivation": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Trpíte úzkostmi nebo si děláte starost více než před prodělaným onemocněním COVID-19?",
    required: [ "feelsAnxious" ],
    "properties": {
      "feelsAnxious": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte problém s pamětí nebo se soustředěním?",
    required: [ "hasConcentrationProblems" ],
    "properties": {
      "hasConcentrationProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Točí se Vám hlava nebo trpíte nevolnostmi?",
    required: [ "hasNausea" ],
    "properties": {
      "hasNausea": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Pociťujete mravenčení?",
    required: [ "hasAcroparestezie" ],
    "properties": {
      "hasAcroparestezie": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Píská nebo bzučí Vám v uších? ",
    required: [ "hasTinnitus" ],
    "properties": {
      "hasTinnitus": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Trpíte průjmy?",
    required: [ "hasDiarrhea" ],
    "properties": {
      "hasDiarrhea": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Máte špatné zažívání nebo nechuť k jídlu?",
    required: [ "hasDigestionProblems" ],
    "properties": {
      "hasDigestionProblems": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Ztratil/a jste hmotnost?",
    required: [ "hasLostWeight" ],
    "properties": {
      "hasLostWeight": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  },
  {
    "type": "object",
    "title": "Míváte vyrážky?",
    required: [ "hasRashes" ],
    "properties": {
      "hasRashes": {
        "title": "",
        "type": "boolean",
        "enum": [ true, false ],
        "enumNames": [ "Ano", "Ne" ],
        "submitOn": [ true, false ]
      }
    }
  }
]

export default schema
